import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import Form from 'antd/lib/form';
import { Input, Button } from 'antd';
import rules from '../../../common/rules/rules';
import { translate } from 'react-i18next';

const { Item } = Form;

@translate()
@Form.create()
export default class AllocationSplitForm extends Component{

    

    onSubmit = e => {
        e.preventDefault()
        const { form, t } = this.props
        form.validateFields((err,values) => {
        if(!err){
            this.props.calculateSellAmount(values.ratio)
        }
        })
    }

    render(){
        const {form, t} = this.props
        const { getFieldDecorator } = form;
        
        
        return (
            <div>
                <Form layout='inline'>
                    <Item label={t('Zadajte percento predajnej sumy')}>
                    {getFieldDecorator('ratio', { rules: [...rules.required, rules.number ,rules.lessThanValue(100), rules.moreThanValue(0)] , initialValue: 100})(
                        <Input size="default" />
                    )}
                    </Item>
                    <Button onClick={this.onSubmit}>Prerátať predajnú cenu</Button>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/allocation-management/components/AllocationSplitForm.js